import { ca } from '@cian/analytics';
import { TRequestCallbackOpener } from '../../types/requestCallback';

export function trackCallbackPopupOpen(label: string, placeType: TRequestCallbackOpener) {
  ca('eventSite', {
    action: `CallBack_popup_open_${placeType}`,
    category: 'CardJK',
    label,
    name: 'oldevent',
    useLastProducts: true,
  });
}
